import React from 'react';
import '../styles/Button.css'; // Ensure this path is correct

function Button({ title, link, styleType = 'outline-custom', size = 'medium', ...props }) {
    return (
      <a href={link} className={`btn ${styleType} ${size} hover-symbol`} {...props}>
        {title}
      </a>
    );
  }

export default Button;
